<template>
    <Layout>
        <app-head :noindex="true" title="Algemene voorwaarden"/>

        <div class="col-lg-7 col-10 mx-auto">

            <div class="px-6 pt-5 mt-2 mt-lg-5">
                <h3 class="display-5 mb-4 mb-lg-2 fw-bold text-center">
                    Algemene voorwaarden
                </h3>
            </div>
<!--            <legal-block title="">-->
                <legal-block-entry first-column-class="" second-column-class="col-sm-12">
                    <template v-slot:content>
                        <div class="my-3">
                            <em>
                                Bij Private Gym houden we van transparantie en eenvoud. Ook vinden we het belangrijk om bepaalde zaken goed te regelen. Dat doen we in deze algemene voorwaarden. Als je bij ons een abonnement afsluit, ga je met deze voorwaarden akkoord. Hieronder hebben we een opsomming gemaakt van de belangrijkste punten. Daarna volgen de complete algemene voorwaarden. Heb je er vragen over? Dan kun je altijd contact met ons opnemen.
                            </em>
                        </div>
                    </template>
                </legal-block-entry>
<!--            </legal-block>-->

            <legal-block title="De 10 belangrijkste punten voor jou">
                <legal-block-entry>
                    <template v-slot:number>
                        1
                    </template>
                    <template v-slot:content>
                        24/7 Toegang tot Private Gym. Het lid heeft het recht om een sporteiland te reserveren dat door Private Gym 24/7 beschikbaar wordt gesteld aan haar leden.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        2.
                    </template>
                    <template v-slot:content>
                        Aanmelden. De aanmelding bij Private Gym komt tot stand als we je gegevens hebben ontvangen, je de algemene voorwaarden hebt geaccepteerd en wij het lidmaatschap hebben bevestigd. Zodra je account is geactiveerd, kan je direct aan de slag en een ‘sporteiland’ reserveren.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.
                    </template>
                    <template v-slot:content>
                        Inloggegevens. Elk lid heeft zijn eigen account in onze app. Het is niet de bedoeling dat je iemand anders van jouw account gebruik laat maken.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        4.
                    </template>
                    <template v-slot:content>
                        Opzeggen lidmaatschap. Je hebt na het sluiten van de overeenkomst één kalendermaand bedenktijd en kan de eerste maand dus de overeenkomst kosteloos opzeggen. Daarna kan je, als je voor een jaarabonnement hebt gekozen, je lidmaatschap alleen tegen het einde van de duur van één jaar schriftelijk opzeggen met het formulier op de website of in de App. In alle andere gevallen kan je tegen het einde van een (vierwekelijkse) periode opzeggen, waarbij een opzegtermijn van één (vierwekelijkse) periode geldt.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        5.
                    </template>
                    <template v-slot:content>
                        Prijswijziging. Als de prijzen van het lidmaatschap binnen drie maanden na het sluiten van de overeenkomst worden gewijzigd of als deze algemene voorwaarden ingrijpend worden gewijzigd, dan kan je de overeenkomst ontbinden.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.
                    </template>
                    <template v-slot:content>
                        Betaling vindt plaats middels automatische incasso. De vergoeding voor het lidmaatschap wordt eens per periode door middel van automatische incasso vooruitbetaald. De automatische incasso vindt telkens na het verstrijken van een periode van vier weken plaats. Zorg er dus voor dat er op dat moment voldoende saldo aanwezig is op je rekening om de afschrijving te laten plaatsvinden, anders zijn we genoodzaakt extra administratiekosten in rekening te brengen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.
                    </template>
                    <template v-slot:content>
                        Privacy. De gegevens die jij aan ons verstrekt worden op een zorgvuldige wijze opgeslagen en verwerkt, waarbij de Gym zich houdt aan de wettelijke voorschriften die volgen uit de Algemene Verordening Gegevensbescherming (AVG). Je hoeft je daarom geen zorgen te maken dat jouw gegevens op straat komen te liggen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        8.
                    </template>
                    <template v-slot:content>
                        Fair use policy. We gaan ervan uit de leden netjes omgaan met de sportfaciliteiten en hun persoonlijke lidmaatschap. Check ook even onze huisregels. Mocht dat onverhoopt niet het geval zijn, dan hebben we de mogelijkheid om je (tijdelijk) de toegang tot de Gym te ontzeggen of extra kosten in rekening te brengen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        9.
                    </template>
                    <template v-slot:content>
                        Bring a friend. Natuurlijk hopen we dat onze community groeit en dat kan het best door de unieke sportervaring met een vriend of vriendin te delen. Meld je vriend/vriendin gratis aan via de app en na onze goedkeuring zijn jullie samen van harte welkom om te sporten. Totdat jouw vriend of vriendin een eigen lidmaatschap heeft, trainen jullie samen op één sporteiland. Wel zo eerlijk voor de rest.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        10.
                    </template>
                    <template v-slot:content>
                        Personal training op aanvraag. Als je graag nog een keer extra – bovenop je abonnement – af wilt spreken met een personal trainer, dan kan dat via de app.
                    </template>
                </legal-block-entry>
            </legal-block>


            <legal-block title="Identiteit">
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        Statutaire naam
                    </template>
                    <template v-slot:content>
                        Private Gym B.V.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        Vestigingsadres
                    </template>
                    <template v-slot:content>
                        Smedenstraat 286 te (7411 RD) Deventer
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        Openingstijden
                    </template>
                    <template v-slot:content>
                        24/7 geopend
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        Bereikbaarheid
                    </template>
                    <template v-slot:content>
                        Maandag t/m zaterdag van 09.00 uur tot 17.00 uur
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        E-mail
                    </template>
                    <template v-slot:content>
                        team [at] privategym.nl
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        KvK-nummer
                    </template>
                    <template v-slot:content>
                        83068791
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10">
                    <template v-slot:number>
                        BTW-nummer
                    </template>
                    <template v-slot:content>
                        NL862713882B01
                    </template>
                </legal-block-entry>
            </legal-block>


            <legal-block title="Definities">
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        App
                    </template>
                    <template v-slot:content>
                        App betekent de mobiele applicatie van de Gym.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Artikel
                    </template>
                    <template v-slot:content>
                        Artikel is een artikel van deze algemene voorwaarden.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Gym
                    </template>
                    <template v-slot:content>
                        Gym betekent de Private Gym-ondernemer.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Personal Trainer
                    </template>
                    <template v-slot:content>
                        Personal Trainer is iedere (rechts)persoon die door de Gym ten behoeve van de uitvoering van de Overeenkomst wordt ingeschakeld.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Lid
                    </template>
                    <template v-slot:content>
                        Lid is iedere partij, zijnde een natuurlijk persoon die handelt buiten zijn bedrijfs- of beroepsactiviteiten, die een Overeenkomst met de Gym heeft gesloten.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Lidmaatschap
                    </template>
                    <template v-slot:content>
                        Lidmaatschap betekent het lidmaatschap van het Lid.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Overeenkomst
                    </template>
                    <template v-slot:content>
                        Overeenkomst betekent de overeenkomst tussen het Lid en de Gym waarin wordt vastgelegd onder welke specifieke voorwaarden en omstandigheden de Gym de sportfaciliteiten faciliteert.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Periode
                    </template>
                    <template v-slot:content>
                        Periode betekent een periode van vier weken.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Privacyverklaring
                    </template>
                    <template v-slot:content>
                        Privacyverklaring is de privacyverklaring op de website van de Gym.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Reservering
                    </template>
                    <template v-slot:content>
                        Reservering is iedere reservering via de App om een sporteiland te gebruiken onder opgaaf van de locatie en tijdstip(pen).
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Schriftelijk
                    </template>
                    <template v-slot:content>
                        Schriftelijk betekent op schrift, per e-mail, via de Website of de App van de Gym of langs een andere tussen het Lid en de Gym overeengekomen elek-tronische weg waarbij berichten worden opgeslagen en binnen redelijke termijn leesbaar kunnen worden gemaakt.
                    </template>
                </legal-block-entry>
                <legal-block-entry first-column-class="col-sm-2" second-column-class="col-sm-10" :first-column-strong="true">
                    <template v-slot:number>
                        Website
                    </template>
                    <template v-slot:content>
                        Website betekent de website van de Gym: https://privategym.nl/.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 3. Toepasselijkheid">
                <legal-block-entry>
                    <template v-slot:number>
                        3.1
                    </template>
                    <template v-slot:content>
                        Deze algemene voorwaarden zijn van toepassing op de Overeenkomst tussen de Gym en het Lid.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.2
                    </template>
                    <template v-slot:content>
                        Als het Lid eenmaal een Overeenkomst met de Gym heeft gesloten onder de toepasselijkheid van deze algemene voorwaarden, zijn deze algemene voorwaarden ook op iedere volgende Overeenkomst met de Gym van toepassing, ook als bij het sluiten van de betreffende Overeenkomst een verwijzing daarnaar niet uitdrukkelijk heeft plaatsgevonden.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.3
                    </template>
                    <template v-slot:content>
                        De bedingen in deze algemene voorwaarden zijn mede gemaakt ten behoeve van bestuurders en werknemers van de Gym en eventuele andere bij de uitvoering van de Overeenkomst betrokkenen zoals een Personal Trainer.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.4
                    </template>
                    <template v-slot:content>
                        De Gym heeft te allen tijde het recht om deze algemene voorwaarden te wijzigen. De wijziging geldt ook ten aanzien van bestaande Overeenkomsten en/of Reserveringen. Het Lid wordt geacht iedere wijziging van deze algemene voorwaarden te hebben geaccepteerd, als deze binnen zeven (7) dagen na kennisgeving van de wijziging zijn bezwaren niet Schriftelijk bij de Gym heeft gemeld. Als er sprake is van een wezenlijke wijziging van de algemene voorwaarden – waarbij een prijswijziging in elk geval niet als een wezenlijke wijziging wordt beschouwd – dan kan een Lid de Overeenkomst uiterlijk binnen veertien (14) dagen na kennisgeving van de wijziging de Overeenkomst per direct Schriftelijk ontbinden.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.5
                    </template>
                    <template v-slot:content>
                        Mocht een bepaling in deze algemene voorwaarden nietig of vernietigbaar zijn, dan heeft dit niet tot gevolg dat deze algemene voorwaarden in hun geheel nietig of vernietigbaar zijn dan wel dat een andere bepaling daarvan (deels) nietig of vernietigbaar is. Als een bepaling in deze algemene voorwaarden nietig of vernietigbaar (en vervolgens vernietigd) mocht zijn, wordt zij door de Gym vervangen door een geldige bepaling die het meest de strekking van de nietige of vernietigde bepaling benadert.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.6
                    </template>
                    <template v-slot:content>
                        Voor zover de Overeenkomst bepalingen bevat die in strijd zijn met deze algemene voorwaarden, prevaleren de bepalingen van de Overeenkomst.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        3.7
                    </template>
                    <template v-slot:content>
                        Voor zover deze algemene voorwaarden zijn vertaald in een andere dan de Nederlandse taal, is de Nederlandse tekst bij verschillen steeds beslissend.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 4. Totstandkoming en inhoud van de Overeenkomst">
                <legal-block-entry>
                    <template v-slot:number>
                        4.1
                    </template>
                    <template v-slot:content>
                        Een Overeenkomst tussen het Lid en de Gym komt tot stand doordat het Lid op de Website of via de App een abonnement afsluit. Het abonnement c.q. de Overeenkomst wordt door de Gym bevestigd via een emailbevestiging. Het Lidmaatschap wordt door de Gym geactiveerd zodra het Lid een rondleiding heeft gehad in een locatie van de Gym, indien dit nog niet heeft plaatsgevonden ten tijde van het sluiten van de Overeenkomst.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        4.2
                    </template>
                    <template v-slot:content>
                        De Overeenkomst tussen het Lid en de Gym houdt in dat aan het Lid tegen betaling toegang wordt verleend tot een locatie waar het Lid met behulp van daartoe voorziene apparatuur aan lichaam en conditie kan werken. Aanvullende en/of afwijkende producten en/of diensten, zoals de begeleiding door een Personal Trainer, worden enkel verleend als dit in de Overeenkomst uitdrukkelijk is vermeld of naderhand op aanvraag van het Lid is overeengekomen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        4.3
                    </template>
                    <template v-slot:content>
                        Alle aanbiedingen en/of kortingsacties van de Gym zijn vrijblijvend en kunnen door de Gym te allen tijde worden herroepen, ook nadat het aanbod door het Lid is aanvaard. Voor zover er tegelijkertijd meerdere aanbiedingen en/of kortingsacties gelden, kan het Lid per Overeenkomst gebruikmaken van enkel één (1) aanbieding of kortingsactie.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 5. Lidmaatschap">
                <legal-block-entry>
                    <template v-slot:number>
                        5.1
                    </template>
                    <template v-slot:content>
                        Nadat de Gym de aanmelding heeft bevestigd, zal de Gym deze beoordelen. Om in aanmerking te komen voor een Lidmaatschap en gebruiksrecht voor de App dient een Lid tenminste:<br/>
                        a.	aantoonbaar ingeschreven te staan op een woonadres in Nederland;<br/>
                        b.	te beschikken over een eigen bankrekening bij een bank binnen het SEPA-gebied en een (elektronische) machtiging voor automatische betaling af te geven;<br/>
                        c.	kennis te hebben genomen van en akkoord te zijn gegaan met (de toepasselijkheid van) deze algemene voorwaarden en de Privacyverklaring; en<br/>
                        d.	NAW-gegevens (Naam, Adres, Woonplaats) en andere gegevens op het aanmeldingsformulier van de Gym te verstrekken.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        5.2
                    </template>
                    <template v-slot:content>
                        De Gym is te allen tijde gerechtigd om een aanmelding zonder opgave van reden te weigeren.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        5.3
                    </template>
                    <template v-slot:content>
                        Als onderdeel van het Lidmaatschap wordt aan elk Lid een gebruiksrecht voor (een account op) de App verschaft. Zowel het Lidmaatschap van de Gym als het gebruiksrecht voor de App is (i) strikt persoonlijk (ii) niet-exclusief, (iii) niet-(sub)licentieerbaar, (iv) niet-overdraagbaar en (v) door de Gym te herroepen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        5.4
                    </template>
                    <template v-slot:content>
                        Leden mogen hun Lidmaatschap en/of hun account op de App niet aan anderen ter beschikking stellen. Leden dragen zelf de verant-woordelijkheid voor het gebruik van hun account, ook als een derde onbevoegd toegang heeft verkregen. Leden zijn verplicht om vereiste (beveiligings-)maatregelen te treffen, zoals het regelmatig veranderen van het wachtwoord. De Gym gaat ervan uit dat degene die zich aanmeldt met het account van het Lid ook daadwerkelijk dat Lid is. Zodra het Lid vermoedt dat een account in handen is van onbevoegden, dan dient het desbetreffend Lid dat onverwijld aan de Gym bekend te maken.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        5.5
                    </template>
                    <template v-slot:content>
                        Als (onbevoegd) gebruik wordt gemaakt van het Lidmaatschap van het Lid door andere personenen dan het Lid zelf, dan kan Private Gym een boete van € 250,00 in rekening brengen en/of een waarschuwing afgeven.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 6. Uitvoering van de Overeenkomst">
                <legal-block-entry>
                    <template v-slot:number>
                        6.1
                    </template>
                    <template v-slot:content>
                        De Gym stelt 7 dagen per week, 24 uur per dag haar sportfaciliteiten in haar locatie(s) beschikbaar aan het Lid. Het Lid kiest een van de locaties van de Gym als zijn/haar 'home Gym'.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.2
                    </template>
                    <template v-slot:content>
                        Het Lid krijgt toegang tot de locatie(s) van de Gym door middel van een toegangssleutel via de App.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.3
                    </template>
                    <template v-slot:content>
                        Het Lid dient voorafgaand aan het gebruik een Reservering aan te melden in de App.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.4
                    </template>
                    <template v-slot:content>
                        Het Lid mag een gast meebrengen naar een locatie van de Gym nadat een verzoek daartoe is goedgekeurd via de App of door een medewerker van de Gym.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.5
                    </template>
                    <template v-slot:content>
                        Het Lid kan bovenop het Lidmaatschap een afspraak inplannen met een Personal Trainer tegen een extra vergoeding die wordt aangegeven in de App.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        6.6
                    </template>
                    <template v-slot:content>
                        Het Lid neemt de huisregels van de Gym in acht, die zijn te raadplegen op https://privategym.nl/huisregels.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 7. Prijs en betaling">
                <legal-block-entry>
                    <template v-slot:number>
                        7.1
                    </template>
                    <template v-slot:content>
                        Tenzij uitdrukkelijk anders is overeengekomen, is het Lid aan de Gym een periodieke vergoeding verschuldigd die is gebaseerd op de overeengekomen duur van het Lidmaatschap. Het Lid is per Periode een termijnbedrag verschuldigd. Alleen de eerste kalendermaand na de ingangsdatum van Overeenkomst betaalt het Lid € 0,99 in afwijking van de termijnbedragen die gelden per Periode.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.2
                    </template>
                    <template v-slot:content>
                        Op aanvraag kan het Lid (extra) trainingen met een Personal Trainer inplannen, waarvoor het Lid separaat een vergoeding betaalt bovenop het lidmaatschapsgeld.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.3
                    </template>
                    <template v-slot:content>
                        De door de Gym gehanteerde tarieven kunnen te allen tijde worden aangepast. Voor het Lid zijn alle aangeboden en overeengekomen prijzen inclusief btw en eventuele andere heffingen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.4
                    </template>
                    <template v-slot:content>
                        Als er binnen drie (3) maanden na het sluiten van de Overeenkomst een prijswijziging plaatsvindt die niet het gevolg is van een wettelijke regeling of bepaling, beschikt het Lid over de bevoegdheid om de Overeenkomst te ontbinden. Deze ontbinding dient binnen veertien (14) dagen na kennisgeving van de prijswijziging Schriftelijk aan de Gym te worden medegedeeld.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.5
                    </template>
                    <template v-slot:content>
                        Het Lid is verplicht de in rekening gebrachte termijnbedragen middels automatische incasso te voldoen. Deze betalingstermijn is een fatale termijn. Opschorting van de betalingsverplichtingen door het Lid is uitdrukkelijk uitgesloten.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.6
                    </template>
                    <template v-slot:content>
                        Als de automatische incasso door het Lid wordt geannuleerd of gestorneerd, is het Lid naast het (openstaande) termijnbedrag een boete verschuldigd van € 10,00. Een en ander onverminderd de overige wettelijke en contractuele rechten van de Gym.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        7.7
                    </template>
                    <template v-slot:content>
                        De Gym is bevoegd de toegang tot haar sportfaciliteiten aan het Lid te ontzeggen, totdat het Lid aan zijn betalingsverplichtingen als genoemd in het vorige artikellid heeft voldaan.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 8. Duur van de Overeenkomst en opschorting van het Lidmaatschap">
                <legal-block-entry>
                    <template v-slot:number>
                        8.1
                    </template>
                    <template v-slot:content>
                        Het Lidmaatschap vangt aan op de dag van de totstandkoming van de Overeenkomst. Het Lidmaatschap is voor een minimale periode van één (1) jaar en wordt na het verstrijken van één jaar stilzwijgend verlengd voor onbepaalde tijd.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        8.2
                    </template>
                    <template v-slot:content>
                        Als het Lid niet in staat is om gebruik te maken van de sportfaciliteiten in de Gym in verband met ziekte of aantoonbaar letsel, dan kan het Lid de Overeenkomst tijdelijk stopzetten voor een periode van ten minste één (1) maand en maximaal drie (3) maanden. De Gym kan aan het Lid in redelijkheid bewijs vragen ter verificatie van de blessure en het Lid zal de Gym de gevraagde inlichtingen verschaffen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        8.3
                    </template>
                    <template v-slot:content>
                        Het Lid kan ook één (1) keer per jaar het Lidmaatschap tijdelijk stopzetten wegens vakantie. De periode van tijdelijk stopzetten be-draagt maximaal drie (3) weken.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        8.4
                    </template>
                    <template v-slot:content>
                        Indien het Lid het Lidmaatschap tijdelijk stopzet dan zal de duur van de Overeenkomst met de duur van de stopzetting worden verlengd.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        8.5
                    </template>
                    <template v-slot:content>
                        Het Lid is geen vergoeding verschuldigd over de duur van de tijdelijke stopzetting van de Overeenkomst.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 9. Klachten">
                <legal-block-entry>
                    <template v-slot:number>
                        9.1
                    </template>
                    <template v-slot:content>
                        Eventuele klachten dienen door het Lid zo spoedig mogelijk, maar uiterlijk binnen vijf (5) werkdagen na de dag waarop de klachtveroorzakende gebeurtenis heeft plaatsgevonden, Schriftelijk aan de Gym kenbaar te worden gemaakt.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        9.2
                    </template>
                    <template v-slot:content>
                        Indien het Lid een klacht (tijdig) kenbaar heeft gemaakt, zoals beschreven in Artikel 9.1, treden de Gym en het Lid zo spoedig mogelijk met elkaar in overleg om de klacht op te lossen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        9.3
                    </template>
                    <template v-slot:content>
                        Klachten schorten de betalingsverplichtingen van het Lid niet op.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 10. Overmacht">
                <legal-block-entry>
                    <template v-slot:number>
                        10.1
                    </template>
                    <template v-slot:content>
                        Van overmacht in de zin van artikel 75 van Boek 6 Burgerlijk Wetboek aan de zijde van de Gym is sprake, als de Gym wordt verhinderd aan haar verplichtingen uit de Overeenkomst of aan de voorbereiding daarvan te voldoen als gevolg van omstandigheden die zij redelijkerwijs niet kan beïnvloeden. Onder overmacht wordt in ieder geval verstaan: (i) overheidsmaatregelen, (ii) uitbraak van een epidemie en/of pandemie (iii) elektriciteitsstoring, (iv) oorlog en (v) hackaanvallen, ransomwareaanvallen en/of DDOS-aanvallen (vi) onbeschikbaarheid van de Gym wegens stormschade en/of lekkage of anderszins.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        10.2
                    </template>
                    <template v-slot:content>
                        De Gym is niet gehouden tot het nakomen van een verplichting gedurende de periode waarin de Gym door overmacht is verhinderd aan haar verplichtingen te voldoen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        10.3
                    </template>
                    <template v-slot:content>
                        Als door overmacht de Gym meer dan twee (2) kalendermaanden haar verplichtingen niet kan nakomen, zijn zowel de Gym als het Lid bevoegd de Overeenkomst voor het niet uitgevoerde gedeelte partieel te ontbinden, zonder dat de Gym en het Lid over en weer tot enige schadevergoeding uit welke hoofde dan ook zijn gehouden.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 11. Aansprakelijkheid en vrijwaring">
                <legal-block-entry>
                    <template v-slot:number>
                        11.1
                    </template>
                    <template v-slot:content>
                        De Gym sluit iedere aansprakelijkheid en/of risicoaansprakelijkheid voor directe schade, indirecte schade, gevolgschade veroorzaakt door de Gym, haar ondergeschikten en/of andere door de Gym bij de Overeenkomst betrokken derden, zoals een Personal Trainer, uitdrukkelijk uit, tenzij de schade het gevolg is van opzet of bewuste roekeloosheid.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        11.2
                    </template>
                    <template v-slot:content>
                        De Gym is niet aansprakelijk voor gegeven adviezen, inlichtingen en/of aanbevelingen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        11.3
                    </template>
                    <template v-slot:content>
                        Mocht de uitsluiting van de aansprakelijkheid in Artikel 11.1 geen standhouden, dan is de schadevergoeding in ieder geval beperkt tot het bedrag dat onder de aansprakelijkheidsverzekering van de Gym in voorkomend geval wordt uitbetaald, te vermeerderen met het bedrag van het eigen risico dat in gevolge de toepasselijke verzekeringsovereenkomst in het desbetreffende geval voor rekening van de Gym komt.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        11.4
                    </template>
                    <template v-slot:content>
                        Het Lid vrijwaart de Gym volledig voor alle aanspraken van derden op de Gym voor enig feit waarvoor de aansprakelijkheid in deze algemene voorwaarden is uitgesloten.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 12. Opzegging van de Overeenkomst">
                <legal-block-entry>
                    <template v-slot:number>
                        12.1
                    </template>
                    <template v-slot:content>
                        Als het Lid en de Gym een Overeenkomst voor bepaalde tijd zijn overeengekomen is (tussentijdse) opzegging van de Overeenkomst door het Lid enkel mogelijk tegen het einde van de looptijd van de Overeenkomst, tenzij anders overeengekomen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        12.2
                    </template>
                    <template v-slot:content>
                        Het Lid kan de Overeenkomst, nadat minimaal drie (3) Perioden zijn verstreken, kosteloos en zonder opzegtermijn opzeggen indien een verhuizing van het Lid tot gevolg heeft dat er geen locatie van de Gym is binnen een straal van 5 kilometer van de nieuwe woonplaats van het Lid. De Gym kan het Lid in redelijkheid vragen om bewijs ter verificatie van de verhuizing.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        12.3
                    </template>
                    <template v-slot:content>
                        Als de Overeenkomst (eventueel na stilzwijgende verlenging) de duur heeft van onbepaalde tijd, kan het Lid de Overeenkomst schriftelijk opzeggen tegen het einde van een Periode met inachtneming van een opzegtermijn van één Periode.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        12.4
                    </template>
                    <template v-slot:content>
                        De Gym heeft zonder opgave van redenen het recht een Overeenkomst Schriftelijk (tussentijds) op te zeggen tegen het einde van de Periode met inachtneming van een opzegtermijn van één Periode.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 13.	Ontbinding van de Overeenkomst">
                <legal-block-entry>
                    <template v-slot:number>
                        13.1
                    </template>
                    <template v-slot:content>
                        De Overeenkomst kan door de Gym met onmiddellijke ingang, en zonder dat een ingebrekestelling is vereist, door middel van een Schriftelijke verklaring aan het Lid worden ontbonden, als het Lid één of meer van de bepalingen uit de Overeenkomst, het huishoudelijk reglement of deze algemene voorwaarden niet nakomt, onverminderd het recht van de Gym om van het Lid schadevergoeding te vorderen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        13.2
                    </template>
                    <template v-slot:content>
                        13.2.	De Overeenkomst kan verder door de Gym met onmiddellijke ingang, en zonder dat een ingebrekestelling is vereist, door middel van een Schriftelijke verklaring aan het Lid worden ontbonden, als:<br/>
                        <br/>
                        a.	Het Lid faillissement aanvraagt of in staat van faillissement wordt verklaard;<br/>
                        b.	Op het Lid de schuldsaneringsregeling ingevolge de Wet Schuldsanering Natuurlijke Personen van toepassing wordt verklaard;<br/>
                        c.	Het Lid komt te overlijden;<br/>
                        d.	Het Lid onder curatele of bewind wordt gesteld; of<br/>
                        e.	Na het sluiten van de Overeenkomst de Gym kennis krijgt van andere omstandigheden die de Gym goede grond geven te vrezen dat de het Lid niet aan zijn/haar verplichtingen zal voldoen;<br/>
                        <br/>
                        een en ander onverminderd het recht van de Gym om van het Lid schadevergoeding te vorderen die in ieder geval bestaat uit de onbetaalde termijnbedragen over de verstreken Perioden en de toekomstige termijnbedragen tot één (1) jaar na de ingangsdatum van de Overeenkomst.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        13.3
                    </template>
                    <template v-slot:content>
                        Het Lid zal de Gym onmiddellijk Schriftelijk informeren zodra een omstandigheid genoemd in Artikel 13.2 zich voordoet of mogelijk gaat voordoen en zal in afwachting van instructies van de Gym passende maatregelen nemen ter bescherming van diens belangen.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 14.	Privacy">
                <legal-block-entry>
                    <template v-slot:number>
                        14.1
                    </template>
                    <template v-slot:content>
                        Bij het gebruik van de App en/of de Website worden persoonsgegevens die door het Lid aan de Gym worden verstrekt opgeslagen en verwerkt. De Gym zal de persoonsgegevens op een behoorlijke en zorgvuldige wijze verwerken en zich houden aan de wettelijke voorschriften die volgen uit de Algemene verordening gegevensbescherming.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        14.2
                    </template>
                    <template v-slot:content>
                        De Gym informeert het Lid binnen vijf (5) werkdagen over ieder verzoek en/of iedere klacht van de toezichthoudende autoriteit of de betrokkene ten aanzien van de persoonsgegevens die worden verwerkt bij het uitvoeren van een Overeenkomst en/of Reservering. Het Lid verleent aan de Gym de medewerking die vereist is om aan de verzoeken van de toezichthoudende autoriteit of betrokkenen te voldoen.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        14.3
                    </template>
                    <template v-slot:content>
                        Meer informatie over de verwerking van persoonsgegevens door de Gym is opgenomen in de Privacyverklaring, te raadplegen via https://privategym.nl/legal/privacy-policy.
                    </template>
                </legal-block-entry>
            </legal-block>

            <legal-block title="Artikel 15.	Verval van recht, toepasselijk recht en forumkeuze">
                <legal-block-entry>
                    <template v-slot:number>
                        15.1
                    </template>
                    <template v-slot:content>
                        Voor zover in deze algemene voorwaarden niet anders is bepaald, vervallen alle (vorderings)rechten van het Lid jegens de Gym in ieder geval één jaar na de dag waarop het vorderingsrecht is ontstaan, tenzij binnen deze termijn de vordering(en) bij de bevoegde rechter aanhangig worden gemaakt.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        15.2
                    </template>
                    <template v-slot:content>
                        Op alle rechtsverhoudingen tussen de Gym en het Lid is uitsluitend Nederlands recht van toepassing.
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        15.3
                    </template>
                    <template v-slot:content>
                        Alle geschillen welke naar aanleiding van door deze algemene voorwaarden beheerste verhoudingen tussen de Gym en het Lid mochten ontstaan, zullen uitsluitend worden onderworpen aan het oordeel van de Nederlandse rechter, meer in het bijzonder de bevoegde rechter van Rechtbank Overijssel.
                    </template>
                </legal-block-entry>
            </legal-block>

        </div>
        <div class="m-5"></div>

    </Layout>
</template>

<script>
import Layout from '../../Components/Layout'
import AppHead from "../../Components/AppHead";
import LegalBlock from "../../Components/Legal/LegalBlock";
import LegalBlockEntry from "../../Components/Legal/LegalBlockEntry";

export default {
    components: {
        LegalBlockEntry,
        LegalBlock,
        AppHead,
        Layout,
    },
    props: {
        user: Object,
    },
}
</script>
